export default "__VITE_ASSET__DXde8ob3__"